<template>
  <CCard
    class="auction-manager-card"
  >
    <CCardHeader class="user-manager-card__header-container">
        <div class="user-manager-card__header">
          <CInput
            class="user-manager-card__header-input"
            size="sm"
            placeholder="Search for auction...."
            :value="$route.query.search"
            @input="onInputSearch"
            @keyup.enter="onInputSearch($event.target.value)"
            @keyup.esc="onInputSearch()"
          />
          <span
            class="cursor-poiner"
            @click="addItem"
          >
            <CIcon
              name="add"
              size="xl"
            />
          </span>
        </div>
    </CCardHeader>
    <CCardBody
      color="white"
      border-color="white"
    >
      <CDataTable
        class="auction-manager__table seo_table"
        :items="computedItems"
        :fields="fields"
        :loading="loading"
        ref="table"
      >
        <template #rowId={item}>
          <td
            :data-row-id="item.id"
          ></td>
        </template> 

        <template #edit-header>
        </template>
        <template #edit={item}>
          <td>
            <CDropdown>
              <template #toggler>
                <CButton class="toggler">
                  <CIcon name="dots" />
                </CButton>
              </template>
              <CDropdownItem
                class="btn btn-info"
                @click="editItem(item)"
              >
                Edit
              </CDropdownItem>
              <CDropdownItem
                class="btn btn-info"
                @click="onDeleteItem(item)"
              >
                Delete
              </CDropdownItem>
            </CDropdown>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CCardFooter class="auction-manager-card__footer">
      <VSeoPagination
        class="auction-manager-card__footer-pagination"
        :current-page.sync="currentPage"
      />
    </CCardFooter>
  </CCard>
</template>
<script>
import {
  createStatisticalMixin,
  statisticalStore
} from '@/mixins/statisticalMixin'
import { auctionManagerStore, createAuctionManagerMixin } from '@/mixins/auctionsManagerMixin'
import { toggleRowClass } from '@/utils/table/toggleRowClass'
import { debounce } from '@/utils/debounce'
import ModalType from '@/utils/dictionaries/modalType'
import api from "@/api/api";
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
import VSeoPagination from '@/components/VSeoPagination.vue'

export default {
  name: 'SeoManagement',

  components: {
    VSeoPagination,
},

  mixins: [
    createAuctionManagerMixin(),
    createCarManagerMixin(),
    createStatisticalMixin()
  ],

  data () {
    return {
      fields: [
        // { key: 'id', label: '' },
        { key: 'pageTitle', label: 'Page Title', _classes: 'username', _style: 'min-width: 125px;max-width: 125px' },
        { key: 'pageUrl', label: 'Page Url', _style: 'min-width: auto;max-width: 300px' },
        { key: 'metaKeywords', label: 'Meta Keywords', _classes: 'auction-verified', _style: 'min-width: 120px;max-width: 140px' },
        { key: 'metaDescription', label: 'Mets Description', _style: 'min-width: 140px;max-width: 140px;text-align: center;' },
        { key: "edit", _style: "max-width: 20px;min-width:20px" }

      ],
      currentPage: 1,
      loading: false,
      searchFn: () => {},
    }
  },

  async created () {
    this.loadData()
    this.searchFn = debounce.call(this, async (term) => {
      const query = {
        ...this.$route.query,
        search: term
      }

      if (!query.search && query.skip) {
        query.skip = 0
      }

      this.$router.push({
        query
      }).catch(() => {})
    }, 200)
  },
  watch: {
    isReload(newValue){
      this.loadData();
    },
    $route () {
      this.loadData()
    }
  },
  computed: {
    isReload() {
      return this[statisticalStore.getterTypes.GETTER_PAGE_RELOAD];
    },
    seos () {
      return this[statisticalStore.getterTypes.GETTER_SEO_LIST]
    },
    computedItems () {
      return this.seos && this.seos.map(a => {
        const item  = {
          id: a.id,
          pageTitle: a.pageTitle,
          pageUrl: a.pageUrl,
          metaDescription: a.metaDescription,
          metaKeywords: a.metaKeywords,
        }
        // this.checkCarTimer(item) TODO: Make status value from awaiting to In progress
        return item
      })
    },

  },

  methods: {
    addItem () {
      this.$modals.open(ModalType.SeoModal, {})
    },
    onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          this.loading = true
          await api.delete(`/seo/${item.id}`);
          this.$modals.close(ModalType.ConfirmationModal);
          this.loadData();
          this.loading = false

        } catch (error) {
          this.loading = false

          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: `Are you sure you want to delete?`,
        buttonText: "Delete",
        onClickButton: deleteAction,
      });
    },
    editItem (item) {
      console.log("edit item")
      const seo = this.seos.find(a => a.id === item.id)
      this.$modals.open(ModalType.SeoModal, { ...seo})
    },
    async loadData () {
      this.loading = true
      await this[statisticalStore.actionTypes.ACTION_LOAD_SEO_LIST]({
        take: this.$route.query.take || 10,
        skip: this.$route.query.skip || 0,
        search: this.$route.query.search,
        all: true
      })
      this.loading = false
      await this[statisticalStore.actionTypes.ACTION_PAGE_REOLAD](false)
    },
    onInputSearch (value) {
      this.searchFn(value)
    },
  }
}
</script>
